import { render, staticRenderFns } from "./Templatepages.vue?vue&type=template&id=2b75f7ac"
import script from "./Templatepages.vue?vue&type=script&lang=js"
export * from "./Templatepages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports